import React from 'react';

const PostalCodeResult = props => {
  if (props.invisible) { return null };
  const { postalInfo } = props;

  const validText = 'サービス対象地域です。';
  const invalidText = '申し訳ありません。このエリアはサービス対象外です。';

  const text = postalInfo ? validText : invalidText;

  const townText = postalInfo ? (
    <div className="PostalCodeTextTown" >
      {`石川県 白山市 ${postalInfo.town}`}
    </div>
  ) : null;

  return (
    <div className="PostalCodeResult" >
      <div className={postalInfo ? 'PostalCodeText' : 'PostalCodeText Error'} >
        {text}
      </div>
      {townText}
    </div>
  );
};

export default PostalCodeResult;
